import { AnswerResults, DepartmentType } from './questions'

export enum ActivityStates {
    IN_PROGRESS = 'inProgress',
    FINISHED = 'finished',
}

export type Activity = {
    id: number
    registrationKeys: string[]
    nonContractRegistrationKeys: string[]
    departmentTypes: DepartmentType[]
    answerResults: AnswerResults[]
    status: ActivityStates
}
